import React from 'react'

export const PhotoStatusBlockedSvg = ({ size = '24', color = 'white' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke={color}>
      <path strokeWidth="1.5" d="M22 12l-5 8.66H7L2 12l5-8.66h10z" />
      <path strokeLinecap="square" strokeWidth="3" d="M8.008 12h8.004" />
    </g>
  </svg>
)
